import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock } from "vue"

import { RouteParams, useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed } from "vue";
import { checkGrant } from "@/core/helpers/navigation";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitLink',
  props: {
    name: {},
    params: {},
    hide: { type: Boolean, default: true }
  },
  setup(__props: any) {

const router = useRouter();
const store = useStore();
const props = __props;

const fullName = computed(
    () => `${store.getters?.currentManagerBaseRoute}.${props.name}`
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(router).hasRoute(fullName.value) && _unref(checkGrant)(fullName.value, _ctx.params))
    ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({ key: 0 }, props, {
        class: _unref(router).hasRoute(fullName.value),
        to: {
                name: fullName.value,
                params: _ctx.params,
            }
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "to"]))
    : (!_ctx.hide)
      ? (_openBlock(), _createElementBlock("div", _normalizeProps(_mergeProps({ key: 1 }, props)), [
          _renderSlot(_ctx.$slots, "default")
        ], 16))
      : _createCommentVNode("", true)
}
}

})